import React from 'react';
import { datetime } from '../../../../../util/library/datetime';
import { SHORT_DATETIME_FORMAT } from '../../../../../util/varibles/constants';
import { IOperation2 } from '../../../../../util/varibles/interface';
import styles from './style.module.scss';

interface IProps {
    data: IOperation2
}

const formatTime = (time?: number) => time
    ? datetime(time).format(SHORT_DATETIME_FORMAT)
    : '--';

const OperationTimeline: React.FC<IProps> = ({ data }) => {
    const { activity_log = [], vessel } = data;
    const startTime = activity_log[0]?.est_start_time;
    const finishTime = activity_log[activity_log.length - 1]?.est_start_time;

    return <div className={styles.section}>
        <div className={styles.times}>
            <div className={styles.startTime}>
                <span className={styles.marker} />
                <span>{formatTime(startTime)}</span>
            </div>
            <span>{formatTime(finishTime)}</span>
        </div>

        <div className={styles.vessel}>
            <span>{vessel?.name || '--'}</span>
        </div>
    </div>;
};

export default OperationTimeline;
